import { render, staticRenderFns } from "./wheelIcon.vue?vue&type=template&id=69740b58&"
import script from "./wheelIcon.vue?vue&type=script&lang=js&"
export * from "./wheelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports